<template>
  <Modal :id="'cpm-add-invoice-modal'" :loading="loading" @cancelled="onCancel">
    <template slot="header">{{ $t('import_setup') }}</template>

    <template slot="body">
      <div v-if="!nextStage" class="form-group">
        <Dropdown
          :options="accountsTV"
          :id="'invoiceProject'"
          class="m2"
          :placeholder="$t('Account')"
          :selected="
            accountsTV.find((e) => e.value == statementSettings.account_id)
          "
          v-on:selectedChange="(e) => onDropdownChange('account_id', e)"
          v-bind="requiredDropdownConfig"
          @validated="(e) => onDropdownValidated('account_id', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'description'"
          v-bind="textFieldConfig"
          :placeholder="$t('description')"
          :value="statementSettings.description"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="invoiceProjectsTV"
          :id="'invoice_project_id'"
          :placeholder="$t('invoice_project')"
          class="m2"
          :selected="
            invoiceProjectsTV.find(
              (e) => e.value == statementSettings.invoice_project_id
            )
          "
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
          v-bind="requiredDropdownConfig"
          @validated="(e) => onDropdownValidated('invoice_project_id', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <Dropdown
          :options="typesTV"
          :id="'digital_physical'"
          class="m2"
          :placeholder="$t('type')"
          :selected="
            typesTV.find((e) => e.value == statementSettings.digital_physical)
          "
          v-on:selectedChange="(e) => onDropdownChange('digital_physical', e)"
          v-bind="requiredDropdownConfig"
          @validated="(e) => onDropdownValidated('digital_physical', e)"
          box
          :listHeight="250"
        ></Dropdown>

        <template
          v-if="
            !['costs', 'income'].includes(statementSettings.digital_physical)
          "
        >
          <Dropdown
            :options="currencyTV"
            :id="'currency_id'"
            :placeholder="$t('currency')"
            class="m2"
            :selected="
              currencyTV.find((e) => e.value == statementSettings.currency_id)
            "
            v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
            v-bind="requiredDropdownConfig"
            @validated="(e) => onDropdownValidated('currency_id', e)"
            box
            :listHeight="250"
          ></Dropdown>
        </template>
        <Dropdown
          :options="periodsTV"
          :id="'statement_period'"
          :placeholder="$t('period')"
          class="m2"
          :selected="
            periodsTV.find((e) => e.value == statementSettings.statement_period)
          "
          v-on:selectedChange="(e) => onDropdownChange('statement_period', e)"
          v-bind="requiredDropdownConfig"
          @validated="(e) => onDropdownValidated('statement_period', e)"
          box
          :listHeight="250"
        ></Dropdown>

        <template
          v-if="
            !['costs', 'income'].includes(statementSettings.digital_physical)
          "
        >
          <TextField
            class="m1"
            :id="'fix_country'"
            v-bind="textFieldConfig"
            :placeholder="$t('fix_country')"
            :value="statementSettings.fix_country"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
        </template>
        <TextField
          class="m1"
          :id="'start_date'"
          v-bind="textFieldConfig"
          :placeholder="$t('from')"
          :value="statementSettings.start_date"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'end_date'"
          v-bind="textFieldConfig"
          :placeholder="$t('to')"
          :value="statementSettings.end_date"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'sender'"
          v-bind="textFieldConfig"
          :placeholder="$t('sender')"
          :value="statementSettings.sender"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'shared_key'"
          v-bind="textFieldConfig"
          :placeholder="$t('shared_key')"
          :value="statementSettings.shared_key"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="dssTV"
          :id="'dss_id'"
          class="m2"
          :selected="dssTV.find((e) => e.value == statementSettings.dss_id)"
          :placeholder="$t('dss_list')"
          v-on:selectedChange="(e) => onDropdownChange('dss_id', e)"
          box
          :listHeight="250"
        ></Dropdown>
        <template
          v-if="['physical'].includes(statementSettings.digital_physical)"
        >
          <TextField
            class="m1"
            :id="'return_handling_fee'"
            v-bind="textFieldConfig"
            :placeholder="$t('return_handling')"
            :value="statementSettings.return_handling_fee"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
        </template>

        <template
          v-if="
            ['digital', 'multi'].includes(statementSettings.digital_physical)
          "
        >
          <TextField
            class="m1"
            :id="'fix_shop'"
            v-bind="textFieldConfig"
            :placeholder="$t('fix_shop')"
            :value="statementSettings.fix_shop"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
          <Dropdown
            :options="usageTypesTV"
            :id="'fix_digital_type'"
            class="m2"
            :selected="
              usageTypesTV.find(
                (e) => e.value == statementSettings.fix_digital_type
              )
            "
            :placeholder="$t('fix_type')"
            v-on:selectedChange="(e) => onDropdownChange('fix_digital_type', e)"
            box
            :listHeight="250"
          ></Dropdown>
        </template>

        <template
          v-if="['digital'].includes(statementSettings.digital_physical)"
        >
        </template>

        <template
          v-if="
            ['thirdparty', 'performance'].includes(
              statementSettings.digital_physical
            )
          "
        >
          <TextField
            class="m1"
            :id="'fix_digital_type'"
            v-bind="textFieldConfig"
            :placeholder="$t('fix_type')"
            :value="statementSettings.fix_digital_type"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
        </template>
        <template
          v-if="
            !['costs', 'income'].includes(statementSettings.digital_physical)
          "
        >
          <TextField
            class="m1"
            :id="'distribution_fee_sales'"
            v-bind="textFieldConfig"
            :placeholder="$t('distribution_fee_sales')"
            :value="statementSettings.distribution_fee_sales"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
          <TextField
            class="m1"
            :id="'distribution_fee_returns'"
            v-bind="textFieldConfig"
            :placeholder="$t('distribution_fee_returns')"
            :value="statementSettings.distribution_fee_returns"
            @valuechanged="onTextFieldValueChange"
          ></TextField>
        </template>
      </div>
      <div v-else>
        <AddImportContact @select_contact="onContactSelect" />
      </div>


    </template>
    <template slot="options">
      <button  class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button v-if="nextStage" style="margin-left:10px" class="dt-button s6" @click.stop="nextStage=false">{{$t('back')}}</button>
      <button v-if="nextStage" class="dt-button v1 with-ico" @click.stop="onOKClick">{{ $t('ok') }}</button>
      <button
        v-if="!nextStage"
        class="dt-button v1 with-ico"
        @click.stop="onNextClick"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
      >
        {{ $t("Next") }} 
      </button>
     
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { DistributionImportsService } from "../../services/imports.service";
import AddImportContact from "./add-imports-contact";
import { createTV } from "../../../../models/text-value.model";
import * as ActionTypes from "../../store/types";
import { importsActions } from "../../store/imports/actions";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { DistributionStoreNamespace as storeNS } from "../../store";
export default {
  components: {
    Modal,
    AddImportContact
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      requiredDropdownConfig: {
        required: true,
        immediateValidation: true,
        showValidationIcons: true,
      },
      loading: false,
      nextStage:false,

      validationResult: {},

      statementSettings: createDefaultStatementSettings(),
      statementSettingsData: null,
    };
  },
  mounted: async function () {
    this.statementSettingsData =
      await DistributionImportsService.fetchAddImportData().then(
        (res) => res.data
      );

    console.log(this.statementSettingsData);
  },
  computed: {
    accountsTV() {
      return createTV(
        this.statementSettingsData?.accounts,
        "account_name",
        "account_id"
      );
    },
    invoiceProjectsTV() {
      return createTV(
        this.statementSettingsData?.invoice_projects,
        "invoice_project_name",
        "invoice_project_id"
      );
    },
    typesTV() {
      return [
        { text: this.$t("digital"), value: "digital" },
        { text: this.$t("physical"), value: "physical" },
        { text: this.$t("costs"), value: "costs" },
        { text: this.$t("thirdparty"), value: "thirdparty" },
        { text: this.$t("performance"), value: "performance" },
        { text: this.$t("income"), value: "income" },
        { text: this.$t("multi"), value: "multi" },
      ];
    },
    currencyTV() {
      return createTV(
        this.statementSettingsData?.currencies,
        "currency_iso",
        "currency_id"
      );
    },
    periodsTV() {
      return [
        { text: this.$t("monthly"), value: "monthly" },
        { text: this.$t("quarterly"), value: "quarterly" },
        { text: this.$t("halfyear"), value: "halfyear" },
        { text: this.$t("year"), value: "year" },
      ];
    },
    dssTV() {
      return createTV(
        this.statementSettingsData?.dss_list,
        "dss_name",
        "dss_id"
      );
    },
    usageTypesTV() {
      return createTV(
        this.statementSettingsData?.usage_types?.map((e) => ({
          text: `${e.usage_type_name} (${e.usage_type})`,
          value: e.usage_type_id,
        })),
        "text",
        "value"
      );
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e?.valid);
    },
  },
  methods: {
    ...mapActionObject(storeNS, importsActions),
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onContactSelect:function(contact){
        console.log("::::",contact)
        this.statementSettings={
          ...this.statementSettings,
          contact_id_invoice:contact.contact_id
        }
    },
    onNextClick: async function (e) {
      this.loading = true;
      this.nextStage=true;
     /* const invoice = await InvoicesService.createInvoice({
        invoice_user_id: this.$store.getters.account.user.user_id,
        invoice_project_id: this.invoiceProject.value,
        currency_id: this.currency.value,
      });
      this.loading = false;
      this.$emit("created", invoice.data.invoice);*/
    },
    onDropdownChange: function (name, value) {
      console.log(name, value);
      
      const shopObject=this.accountsTV.find(e=>e.value==value.value)
      const fixShop=name=='account_id'?shopObject.text:this.statementSettings.fix_shop
      

      //const fixShop= name=='account_id'?this.accountsTV.find(e=>e.value==value.value):'';
       console.log({ "this.statementSettings": fixShop });
      this.statementSettings = {
        ...this.statementSettings,
        [name]: value.value,
        fix_shop:fixShop
      };

      console.log({ "this.statementSettings:::": this.statementSettings,shopObject, fixShop });
      
    },
    onTextFieldValueChange: function (name, value) {
      this.statementSettings = {
        ...this.statementSettings,
        [name]: value,
      };
    },

    onDropdownValidated(name, value) {
      this.$set(this.validationResult, name, value);
    },

    onOKClick:async function(){
        await DistributionImportsService.newEditStmtSettings({...this.statementSettings});
        this.onCancel();
        this[ActionTypes.ImportsList.FETCH.ALL]();
        
    }

    //MARK: Methods
  },
};
const createDefaultStatementSettings = () => {
  return {
    account_id: undefined,
    description: undefined,
    invoice_project_id: undefined,
    digital_physical: undefined,
    statement_period: undefined,
    fix_country: undefined,
    start_date: undefined,
    end_date: undefined,
    dss_id: undefined,
    sender: undefined,
    shared_key: undefined,
    currency_id: undefined,
    fix_shop: undefined,
    fix_digital_type: undefined,
    distribution_fee_sales: undefined,
    distribution_fee_returns: undefined,
    contact_id_invoice: undefined,

    return_handling_fee: undefined,
  };
};
</script>

<style lang="scss">
.cpm-add-invoice-modal {
}
</style>
